import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild, ViewContainerRef } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { AuxiliaryDataFieldSchemaInterface, AuxiliaryDataSearchIntegerOperation } from '@vendasta/account-group';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { apiToGalaxy, calculateCurrencyDisplay, maxValue, minValue } from '../../currency';
import { AuxiliaryDataSearchInfoInterface, FilterHandler } from '../auxiliary-data-accounts-table-filters.service';
export class CurrencyFilterHandler implements FilterHandler {
  formControl: FormControl;
  schema: AuxiliaryDataFieldSchemaInterface;
  formControlEndRange: FormControl;

  constructor(public fieldSchema: AuxiliaryDataFieldSchemaInterface) {
    this.formControl = new FormControl();
    this.formControl.setValidators([]);
    this.formControlEndRange = new FormControl();
    this.formControlEndRange.setValidators([]);
    this.schema = fieldSchema;
  }

  render(viewContainerRef: ViewContainerRef): void {
    viewContainerRef.clear();
    const component = viewContainerRef.createComponent<CurrencyFilterRendererComponent>(
      CurrencyFilterRendererComponent,
    );
    component.instance.control = this.formControl;
    component.instance.validators = [];
    component.instance.controlEndRange = this.formControlEndRange;
    component.instance.currencyCode = this.schema.currencyCode;
  }
  filterOperation(operation: AuxiliaryDataSearchIntegerOperation): AuxiliaryDataSearchInfoInterface {
    return {
      filter: {
        fieldId: this.schema?.fieldId,
        filterRange: {
          beginRange: this.formControl?.value?.toString() || '',
          endRange: this.formControlEndRange?.value?.toString() || '',
        },
        operation: {
          currencyOperation: operation,
        },
      },
      fieldName: this.schema?.fieldName,
      filterValue: 'from ' + this.formControl?.value?.toString() + ' to ' + this.formControlEndRange?.value?.toString(),
      operationName: '',
    };
  }
  hasModification(): boolean {
    return this.formControl.dirty;
  }
}

@Component({
  standalone: true,
  template: `
    <glxy-form-field #formFieldBegin id="currency" [size]="'large'" [prefixText]="currencyCode">
      <input matInput (keydown)="key($event)" (keyup)="key($event)" #inputBegin />
    </glxy-form-field>
    <glxy-form-field #formFieldEnd id="currency" [size]="'large'" [prefixText]="currencyCode">
      <input matInput (keydown)="keyEndRange($event)" (keyup)="keyEndRange($event)" #inputEnd />
    </glxy-form-field>
  `,
  imports: [CommonModule, GalaxyFormFieldModule, MatInputModule, ReactiveFormsModule, TranslateModule],
})
export class CurrencyFilterRendererComponent {
  @ViewChild('inputBegin') input: ElementRef;
  @ViewChild('inputEnd') inputEnd: ElementRef;

  maxValue = maxValue;
  minValue = minValue;

  control!: FormControl;
  controlEndRange: FormControl;
  currencyCode!: string;

  validators: any[];

  key(event: any): void {
    const num: number = calculateCurrencyDisplay(event);
    if (num) {
      this.input.nativeElement.value = apiToGalaxy(num).toFixed(2);
    } else {
      this.input.nativeElement.value = null;
    }
    this.control.setValue(num);
    this.control.markAsDirty();
  }

  keyEndRange(event: any): void {
    const num: number = calculateCurrencyDisplay(event);
    if (num) {
      this.inputEnd.nativeElement.value = apiToGalaxy(num).toFixed(2);
    } else {
      this.inputEnd.nativeElement.value = null;
    }
    this.controlEndRange.setValue(num);
    this.controlEndRange.markAsDirty();
  }
}
